import { render, staticRenderFns } from "./GOODS_highLights.vue?vue&type=template&id=8208b170&"
import script from "./GOODS_highLights.vue?vue&type=script&lang=js&"
export * from "./GOODS_highLights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports